import React from 'react';
import PropTypes from 'prop-types';
import DialogHeader from '../components/DialogHeader/DialogHeader';
import DialogContent from '../components/DialogContent/DialogContent';
import DialogActions from '@mui/material/DialogActions';

const DefaultDialog = ({
  DialogHeaderProps = {},
  DialogContentProps = {},
  DialogActionsProps,
  handleClose,
  children,
  actions,
  footer
}) => {
  return (
    <>
      {DialogHeaderProps && (
        <DialogHeader
          onClose={handleClose}
          actions={actions}
          {...DialogHeaderProps}
        />
      )}
      <DialogContent
        // we pass children as a prop so we can control the order (in case children also passed via DialogContentProps)
        children={children}
        {...DialogContentProps}
      />
      {footer && (
        <DialogActions {...DialogActionsProps}>{footer}</DialogActions>
      )}
    </>
  );
};

DefaultDialog.propTypes = {
  DialogHeaderProps: PropTypes.shape({
    title: PropTypes.string.isRequired,
    /**
     * props available in [Tooltip](./index.html?path=/docs/components-feedback-tooltip--docs) component
     **/
    TooltipProps: PropTypes.object,
    description: PropTypes.node,
    disclaimer: PropTypes.string,
    /**
     * props available in Material's [DialogTitle](https://mui.com/material-ui/api/dialog-title/) component
     **/
    DialogTitleProps: PropTypes.object
  }),
  /**
   * props available in Material's [DialogContent](https://mui.com/material-ui/api/dialog-content/) component
   **/
  DialogContentProps: PropTypes.object,
  /**
   * props available in Material's [DialogActions](https://mui.com/material-ui/api/dialog-actions/) component
   **/
  DialogActionsProps: PropTypes.object,
  children: PropTypes.node,
  actions: PropTypes.node,
  footer: PropTypes.node
};

export default DefaultDialog;
